import axios, { type AxiosError } from 'axios';
import commonUtils from './common';
import store from '@/store';
import { refreshTokens } from '@/services/tokenExchange';
import { isForcedSessionAuthError, triggerForcedSessionLogout } from '@/utils/forcedSessionLogout';

const apiSource = axios.create();

apiSource.interceptors.request.use(async config => {
  try {
    if (
      !!localStorage.getItem('token') &&
      commonUtils.shouldTokenRefresh(localStorage.getItem('token') ?? '')
    ) {
      const newToken = await refreshTokens(store.dispatch);
      if (newToken) {
        localStorage.setItem('token', newToken);
      }
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const googleToken = localStorage.getItem('X-google-token');
    if (googleToken && googleToken !== 'undefined' && googleToken !== 'null') {
      config.headers['X-google-token'] = googleToken;
    }

    return config;
  } catch (error) {
    console.error('Error in apiSource request interceptor:', error);
    return Promise.reject(error);
  }
});

apiSource.interceptors.response.use(
  response => response,
  (error: AxiosError) => {
    if (isForcedSessionAuthError(error)) {
      triggerForcedSessionLogout();
    }
    return Promise.reject(error);
  }
);

export default apiSource;
